<template>
    <div class="article">
        <Headline/>
        <BackButton/>
        <h3 class="label">Impressum</h3>
        <div class="text">
            <p class="speechBubble-right halfWidth">
                Hallo, ich hätte gerne eure Kontaktdaten!
            </p>
            <br><br>
            <p class="speechBubble-left halfWidth">
                Gerne doch!<br><br>

                Timo Zikeli<br>
                Färbermühlgasse 13/5/12<br>
                1230 Wien<br>
                Österreich<br>

                Email: <a href="mailto:kontakt@wersglaubt_SPAMPROTECTION_.at" onclick="this.href=this.href.replace(/_SPAMPROTECTION_/,'')">kontakt [at] wersglaubt.at</a>
            </p>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Component from 'vue-class-component';
    import answers from "@/assets/answers";
    import Headline from "@/components/Headline";
    import BackButton from "@/components/BackButton";

    @Component({
        components: {BackButton, Headline},
    })
    export default class Impressum extends Vue {

    }
</script>
<style scoped lang="scss">
    @import "@/stylesheets/SpeechBubble.scss";

    .article {

        $titleFontSize: 40px;


        width: 90vw;
        max-width: 1000px;
        margin: 0 auto;

        .label {
            font-weight: 900;
            text-align: left;
            font-size: $titleFontSize;
            font-variant: small-caps;
        }

        .text {
            font-size: 20px;
            line-height: 30px;

            padding: 15px;

            p {
                display: inline-block;
                text-align: left;
            }
        }
    }
</style>
<style>

</style>
